import { useState } from 'react'
import {
  Edit,
  EditButton,
  ListButton,
  SimpleForm,
  TopToolbar,
  useLocale,
  useRecordContext,
  useTranslate,
} from 'react-admin'
import { ToggleI18nButton, UpsertCategory } from '~/components'

const CategoryName = (props) => {
  const record = useRecordContext(props)

  const translate = useTranslate()
  return (
    <span>
      {translate(`resources.categories.name`, { smart_count: 1 })}: {record ? `${record.name}` : ''}
    </span>
  )
}

const CategoryEditActions = ({ showI18n, setShowI18n }) => {
  const locale = useLocale()
  // From context: react-admin 5 passes actions no `data`, so the button back
  // to the section never showed.
  const data = useRecordContext()
  return (
    <TopToolbar>
      <ToggleI18nButton showI18n={showI18n} setShowI18n={setShowI18n} />
      {data?.section && (
        <EditButton
          record={{ id: data.section_id }}
          label={data.section.translated_name?.[locale] || data.section.slug}
        />
      )}
      <ListButton label='resources.categories.title' />
    </TopToolbar>
  )
}

export const CategoryEdit = (props, record) => {
  const [showI18n, setShowI18n] = useState(false)

  return (
    <Edit
      title={<CategoryName />}
      actions={<CategoryEditActions showI18n={showI18n} setShowI18n={setShowI18n} />}
      {...props}
      redirect='list'
    >
      <SimpleForm warnWhenUnsavedChanges>
        <UpsertCategory {...props} showI18n={showI18n} />
      </SimpleForm>
    </Edit>
  )
}

export default CategoryEdit
